import script from "./PantallaTatami.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaTatami.vue?vue&type=script&setup=true&lang=js"

import "./PantallaTatami.vue?vue&type=style&index=0&id=513271fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513271fa"]])

export default __exports__